import { ERR_INVALID_ARGUMENT, newError } from "../../utils/error";
import { Money } from "./BasketTypes";
/**
 * Helper class for CalculationSheet handling.
 */
export class CalculationSheetInfo {
    get procedure() {
        return (this.mProcedure);
    }
    get sheet() {
        return (this.mSheet);
    }
    get purchasePrice() {
        return (this.mPurchasePrice);
    }
    get unitPurchasePrice() {
        return (this.mUnitPurchasePrice);
    }
    get salesPrice() {
        return (this.mSalesPrice);
    }
    get unitSalesPrice() {
        return (this.mUnitSalesPrice);
    }
    get itemNetPrice() {
        return (this.mItemNetPrice);
    }
    get unitItemNetPrice() {
        return (this.mUnitItemNetPrice);
    }
    get netPrice() {
        return (this.mNetPrice);
    }
    get unitNetPrice() {
        return (this.mUnitNetPrice);
    }
    get grossPrice() {
        return (this.mGrossPrice);
    }
    get unitGrossPrice() {
        return (this.mUnitGrossPrice);
    }
    constructor(pProc, pSheet) {
        this.mProcedure = pProc;
        this.mSheet = pSheet;
        this.prepareInfo();
    }
    /**
     * Returns the tags of a CalculationLine as Set which is cached internally.
     */
    getLineTags(pLine) {
        const tProcLine = this.mProcedure.getProcedureLine(pLine.level, pLine.counter, true);
        if (tProcLine == null)
            throw newError(ERR_INVALID_ARGUMENT, "unknown calculation line");
        return (this.procedure.getLineTags(tProcLine));
    }
    prepareInfo() {
        for (const tLine of this.mSheet.lines) {
            const tProcLine = this.mProcedure.getProcedureLine(tLine.level, tLine.counter, true);
            if (tProcLine == null)
                continue;
            const tTags = tProcLine.tags;
            if (tTags == null || tTags.length < 1)
                continue;
            for (const tTag of tTags) {
                switch (tTag) {
                    case ("GROSS_PURCHASE_PRICE"):
                        this.mPurchasePrice = tLine.value;
                        this.mUnitPurchasePrice = this.getUnitPrice(tLine.value, tLine.amount);
                        break;
                    case ("GROSS_SALES_PRICE"):
                        this.mSalesPrice = tLine.value;
                        this.mUnitSalesPrice = this.getUnitPrice(tLine.value, tLine.amount);
                        break;
                    case ("ITEM_NET_VALUE"):
                        this.mItemNetPrice = tLine.value;
                        this.mUnitItemNetPrice = this.getUnitPrice(tLine.value, tLine.amount);
                        break;
                    case ("NET_VALUE"):
                        this.mNetPrice = tLine.value;
                        this.mUnitNetPrice = this.getUnitPrice(tLine.value, tLine.amount);
                        break;
                    case ("FINAL_VALUE"):
                        this.mGrossPrice = tLine.value;
                        this.mUnitGrossPrice = this.getUnitPrice(tLine.value, tLine.amount);
                        break;
                }
            }
        }
    }
    getUnitPrice(pValue, pAmount) {
        if (pValue == null)
            return (undefined);
        let tNewValue = pValue.value;
        if (pAmount != null) {
            tNewValue = pAmount.value;
        }
        else {
            if (tNewValue != null && this.mSheet.quantity != null &&
                this.mSheet.quantity.value != null && this.mSheet.quantity.value != 0.0) {
                tNewValue = tNewValue / this.mSheet.quantity.value;
            }
        }
        const tMoney = new Money();
        tMoney.value = tNewValue;
        tMoney.currency = pValue.currency;
        return (tMoney);
    }
}
